export default {
  debtReminders: {
    stopTracking: "Detener seguimiento",
    stopTrackingHint: "Los envíos continúan; se mantiene el bloqueo de 3 días.",
    pending: "Envío en curso",
    notification: "Notificación",
    neverSent: "Nunca enviado",
    debtCount: "Cobros",
    notificationHistory: "Notificaciones de cobro",
    viewHistory: "Historial",
    cooldown: "Espera 3 días entre envíos",
    unknown: "Resultado incierto; envío bloqueado por 3 días",
    simulated: "Simulado: no se envió ningún correo",
    lastAttempt: "Último intento",
    nextAllowed: "Próximo envío permitido",
    history: "Historial de cobros (últimos 50 intentos)",
    noHistory: "Sin envíos registrados",
    operator: "Solicitado por",
    chargeLink: "Ver cobro",
    status: {QUEUED: "Programado",DELIVERED: "Entregado",READ: "Leído",CANCELLED: "Cancelado",PREPARING: "Preparando",SENDING: "Enviando / esperando confirmación",ACCEPTED: "Aceptado por el servicio de correo",FAILED: "Fallo confirmado",UNKNOWN: "Resultado incierto",SIMULATED: "Simulado"},
    help: "Selecciona personas para enviar un solo correo por deudor con todos sus cobros vencidos. Los enlaces requieren pagos en línea. Hasta 100 personas por envío.",
    select: "Seleccionar",
    count: "Movimientos adeudados",
    result: "Resultado",
    send: "Enviar correo de cobro",
    filterAll: "Filtrar todos los movimientos",
    missingEmail: "Sin correo registrado",
    sent: "Correo enviado",
    noDebt: "Ya no hay cobros vencidos",
    failed: "Error: revisa el correo y la disponibilidad de los enlaces de pago",
    busy: "Envío en curso",
    sendError: "No se pudo confirmar el envío. Revisa el resultado antes de reintentar.",
    retry: "Reintentar",
  },
	title: "Gestión Finanzas",
	subtitle: "Gestión financiera del templo",
	menu: {
		dashboard: "Panel",
		funds: "Fondos",
		movements: "Movimientos",
		reports: "Cierre",
		integrations: "Integraciones",
	},
	categories: {
		title: "Categorías de Fondo",
		newCategory: "Nueva Categoría",
		editCategory: "Editar Categoría",
		name: "Nombre",
		fundsCount: "Fondos vinculados",
		searchPlaceholder: "Buscar categorías...",
		noCategories: "No hay categorías registradas",
		noCategoriesSubtext: "Cree categorías para organizar los fondos del templo",
		confirmDelete: "¿Está seguro de que desea eliminar la categoría \"{name}\"?",
		stats: {
			total: "Categorías",
		},
		validation: {
			nameRequired: "El nombre es obligatorio",
			nameMaxLength: "El nombre debe tener como máximo 100 caracteres",
		},
	},
	funds: {
		title: "Fondos",
		newFund: "Nuevo Fondo",
		editFund: "Editar Fondo",
		name: "Nombre",
		category: "Categoría",
		description: "Descripción",
		createCategoryLink: "Crear categoría de fondo",
		recurring: {
			label: "Habilitar cobros recurrentes",
			hint: "Permite cobrar por persona (mensualidad, diezmo) en la pestaña Cobros. Desactivado, el fondo solo recibe ingresos sueltos.",
			disableNote: "Para desactivar, el fondo no puede tener cobros activos.",
		},
		isFeatured: "Destacado",
		color: "Color",
		isFeaturedHint: "Los fondos destacados aparecen en la parte superior con acceso rápido",
		targetAmount: "Meta",
		deadline: "Plazo",
		isActive: "Activo",
		perpetual: "Perpetuo",
		goalBased: "Con meta",
		committed: "Previsto",
		collected: "Recaudado",
		transferred: "Transferido",
		expenses: "Gastos",
		balance: "Saldo",
		groupFlow: "Movimiento del período",
		groupStatus: "Situación del fondo",
		period: "Período",
		periodAll: "Acumulado",
		windowMonthly: "por mes",
		accumulatedBalance: "Saldo acumulado",
		windowAccumulated: "acumulado",
		subscribers: "Suscriptores",
		noFunds: "No hay fondos registrados",
		noFundsSubtext: "Cree fondos para gestionar los ingresos del templo",
		searchPlaceholder: "Buscar fondos...",
		featuredFunds: "Destacados",
		allFunds: "Todos los fondos",
		filters: {
			category: "Categoría",
			status: "Estado",
			active: "Activos",
			inactive: "Inactivos",
			clearFilters: "Limpiar filtros",
		},
		stats: {
			total: "Fondos",
			active: "Activos",
			featured: "Destacados",
			totalBalance: "Saldo sumado",
		},
		validation: {
			nameRequired: "El nombre es obligatorio",
			nameMaxLength: "El nombre debe tener como máximo 150 caracteres",
			categoryRequired: "La categoría es obligatoria",
		},
	},
	fundTabs: {
		dashboard: "Panel",
		movements: "Movimientos",
		recorrencias: "Recurrencias",
		expenses: "Gastos",
	},
	income: {
		title: "Nuevo Ingreso",
		modeNow: "Ahora",
		modeOpen: "Pendiente (por cobrar)",
		modeInstallment: "En cuotas",
		modeRecurring: "Recurrente",
		saved: "Ingreso registrado con éxito",
		collisionTitle: "Cobro pendiente encontrado",
		collisionText: "{name} ya tiene {count} cobro(s) pendiente(s) en este fondo y mes ({amount}). ¿Qué desea hacer?",
		settleIt: "Dar de baja",
		createAnyway: "Crear ingreso nuevo",
	},
	sales: {
		title: "Entradas",
		newSale: "Nuevo Ingreso",
		description: "Descripción",
		descriptionHint: "De qué se trata (ej: donación, mensualidad extra, venta, rifa)",
		saleDate: "Fecha",
		personOptionalHint: "Opcional — deje en blanco para entrada no identificada",
		saved: "Movimiento registrado con éxito",
		searchPlaceholder: "Buscar por descripción o persona...",
		noSales: "Ninguna entrada registrada",
		noSalesSubtext: "Registre entradas sueltas de este fondo (donaciones, ventas, recaudaciones)",
		totalThisView: "Total",
		modePaid: "Pagado ahora",
		modeOpen: "Pendiente (por cobrar)",
		filterAll: "Todos",
		filterOpen: "Pendientes",
		filterPaid: "Pagados",
		totalOpen: "Pendiente",
		totalReceived: "Recibido",
	},
	charges: {
		title: "Cobros",
		subscriptions: "Inscripciones",
		newCharge: "Crear Cobro",
		batchCharge: "Cobro en lote",
		batchChargeTitle: "Cobro en lote",
		batchChargeCreated: "{count} cobros creados",
		batchChargePartial: "{success} de {total} cobros creados",
		batchChargeAllFailed: "No fue posible crear los cobros",
		person: "Persona",
		people: "Personas",
		amount: "Monto",
		mode: "Modo",
		recurring: "Recurrente",
		oneTime: "Único",
		lumpSum: "Al contado",
		lumpSumDesc: "Se creará un único cobro.",
		recurringDesc: "Se creará un cobro cada mes.",
		oneTimeDesc: "Se cobrará una cuota cada mes.",
		dueDay: "Día de vencimiento",
		dueDayHint: "Día del mes para vencimiento (1-28)",
		nextChargeHint: "Próxima cuota: generada el {generated}, con vencimiento el {due}",
		installments: "Cuotas",
		firstImmediate: "Primera cuota vence hoy",
		exempt: "Exentar",
		unexempt: "Quitar exención",
		exemptReason: "Motivo de exención",
		exemptNotes: "Observaciones (dato sensible)",
		deactivate: "Desactivar cobro",
		reactivate: "Reactivar",
		noCharges: "No hay cobros en este fondo",
		noChargesSubtext: "Cree cobros para gestionar pagos",
		status: {
			active: "Activa",
			exempt: "Exenta",
			inactive: "Inactiva",
		},
		reasons: {
			FINANCIAL: "Financiero",
			HEALTH: "Salud",
			SENIOR: "Mayor",
			LEADERSHIP: "Liderazgo",
			OTHER: "Otro",
		},
		editCharge: "Editar Cobro",
		editRecurrence: "Editar recurrencia",
		history: "Historial",
		historyTitle: "Historial de Cambios",
		noHistory: "Ningún cambio registrado",
		historyFields: {
			amount: "Valor",
			dueDay: "Día de vencimiento",
			installments: "Cuotas",
		},
		searchPerson: "Buscar persona...",
		maxInstallmentsHint: "Máximo {n} cuotas (plazo del fondo: {date})",
		enrollExempt: "Crear como exento",
		viewRecurrences: "Recurrencias",
		viewCalendar: "Calendario",
		newOpenCharge: "Nuevo cobro pendiente",
		chargeCreated: "Cobro pendiente creado",
		dueDate: "Vencimiento",
		personOpenHint: "Quién va a saldar este cobro",
		pay: "Dar de baja",
		payCharge: "Dar de baja",
		chargePaid: "Baja registrada",
		validation: {
			personRequired: "La persona es obligatoria",
			personsRequired: "Seleccione al menos una persona",
			amountRequired: "El monto es obligatorio",
			installmentsRequired: "Número de cuotas obligatorio para único",
			installmentsExceedDeadline: "El número de cuotas excede el plazo del fondo ({date})",
			exemptReasonRequired: "El motivo de exención es obligatorio",
			descriptionRequired: "La descripción es obligatoria",
			dueDayRange: "Indique un día entre 1 y 28",
			dueDateRequired: "El vencimiento es obligatorio",
			dueDatePast: "El vencimiento no puede ser en el pasado",
		},
	},
	movements: {
		reversedTrail: "Motivo del estorno",
		title: "Movimientos",
		registerPayment: "Registrar Pago",
		amount: "Monto",
		amountPaid: "Monto pagado",
		method: "Método",
		referenceMonth: "Mes de referencia",
		notes: "Observaciones",
		anonymous: "Anónimo",
		anonymousHint: "Deje en blanco para modo anónimo",
		fund: "Fondo",
		amountBelowCommitted: "Atención: valor menor que el previsto ({amount})",
		earlierMonthUnpaid: "Atención: hay meses anteriores no pagados",
		effectiveDate: "Fecha efectiva",
		cancel: "Cancelar pago",
		confirmCancel: "¿Está seguro de cancelar este pago?",
		reverse: "Reversar movimiento",
		reverseShort: "Reversar",
		confirmReverse: "¿Reversar este movimiento?",
		reversalReason: "Motivo del reverso",
		reopenCharge: "Volver a dejar el cobro pendiente",
		reopenChargeHint: "La persona vuelve a deber este mes.",
		status: {
			PENDING: "Pendiente",
			PAID: "Pagado",
			OVERDUE: "Atrasado",
			WAIVED: "Dispensado",
			CANCELLED: "Cancelado",
			REVERSED: "Reversado",
			FORGIVEN: "Condonado",
		},
		methods: {
			CASH: "Efectivo",
			PIX: "PIX",
			TRANSFER: "Transferencia",
			OTHER: "Otro",
		},
		noMovements: "No hay movimientos",
		attachment: "Comprobante",
		attachmentHint: "Adjunte una foto del comprobante (opcional)",
		residualForgiveWarning: "El monto ingresado es menor que el cobrado. La diferencia será perdonada — no se generará ningún cobro adicional.",
		residualCheckboxLabel: "Generar cobro por el saldo restante ({amount})",
		residualCheckboxHint: "Crea un nuevo cobro pendiente para que la persona pague después. Si no se marca, la diferencia se perdona.",
		residualAlwaysInfo: "Se generará automáticamente un cobro por el saldo restante ({amount}).",
		forgivenReasonLabel: "Motivo del perdón de {amount}",
		forgivenReasonHint: "Obligatorio: la casa está renunciando a este importe, y la rendición de cuentas debe decir por qué.",
		partialSettleTrail: "Pago parcial",
		chargedAmount: "Importe cobrado",
		receivedAmount: "Importe recibido",
		forgivenAmount: "Perdón de cobro",
		residualAmount: "Saldo restante",
		forgivenReasonTitle: "Motivo del perdón",
		validation: {
			forgivenReasonRequired: "Indique el motivo del perdón",
			amountRequired: "El monto es obligatorio",
			methodRequired: "El método es obligatorio",
			referenceMonthRequired: "Mes de referencia obligatorio",
			fundRequired: "El fondo es obligatorio",
		},
	},
	movementFilters: {
		transfers: "Transferencias",
		transferHint: "Las transferencias aparecen en el total Transferido y en el saldo realizado. No se incluyen en Recibido ni Pagado.",
		applyHint: "Elija el intervalo y pulse Aplicar. Las etiquetas siguientes muestran los filtros en uso.",
		period: "Período",
		dateBasis: "Fecha considerada",
		type: "Tipo",
		situation: "Situación",
		from: "Desde",
		to: "Hasta",
		apply: "Aplicar",
		invalidRange: "Ingrese un intervalo válido con inicio anterior o igual al fin.",
		search: "Buscar persona, descripción o código…",
		more: "Más filtros",
		method: "Forma de pago",
		minAmount: "Importe mínimo",
		maxAmount: "Importe máximo",
		invalidAmounts: "Ingrese importes válidos con mínimo menor o igual al máximo.",
		all: "Todo el historial",
		current: "Este mes",
		previous: "Mes anterior",
		custom: "Personalizado",
		reference: "Mes de referencia",
		due: "Vencimiento",
		paid: "Pago",
		quickOverdue: "Por cobrar vencido",
		quickOverdueExpense: "Cuentas por pagar vencidas",
		quickDueSoon: "Vence en 7 días",
		quickWeek: "Por pagar esta semana",
		quickWeekIncome: "Por cobrar esta semana",
		quickToday: "Movido hoy",
		quickPaid: "Pagados este mes",
	},
	movementsPage: {
		exportCsv: "Exportar CSV",
		printReport: "Imprimir",
		reportCount: "{count} de {total} registros de los filtros seleccionados (límite: 2.000).",
		reportError: "No se pudo generar el informe. Inténtalo de nuevo.",
		income: "Entrada",
		expense: "Salida",
		title: "Movimientos",
		subtitle: "Extracto general de ingresos, gastos y transferencias",
		searchPerson: "Buscar por persona...",
		allTypes: "Todos los tipos",
		allFunds: "Todos los fondos",
		allCategories: "Todas las categorías",
		allStatuses: "Todos los estados",
		typeIncome: "Ingreso",
		typeExpense: "Gasto",
		typeTransfer: "Transferencia",
		noMovements: "No se encontraron movimientos",
		noMovementsSubtext: "Registre ingresos, gastos o transferencias para ver el extracto",
		type: "Tipo",
		clearFilters: "Limpiar filtros",
		dueWindow: "Vencimiento: {from} a {to}",
		totalsOfFilter: "Total del filtro:",
		totalReceived: "Recibido",
		totalToReceive: "Por cobrar",
		totalPaid: "Pagado",
		totalToPay: "Por pagar",
		realizedBalance: "Saldo realizado",
		uncountedNotice: "Fuera de estos totales: {count} (anulado, cancelado o exento)",
		columns: {
			date: "Fecha",
			code: "Código",
			type: "Tipo",
			person: "Persona",
			fund: "Fondo",
			category: "Categoría",
			referenceMonth: "Mes Ref.",
			amount: "Valor",
			method: "Método",
			status: "Estado",
			description: "Descripción",
		},
		anonymous: "Anónimo",
	},
	grid: {
		title: "Contribuciones",
		member: "Miembro",
		noData: "Sin datos para mostrar",
		noDataSubtext: "Inscriba personas en este fondo para ver la cuadrícula",
		paymentDetail: "Detalles del Pago",
		tooltipPaid: "Pagado — clic para ver detalles",
		tooltipPending: "Pendiente — clic para registrar",
		tooltipOverdue: "Atrasado — clic para registrar",
		tooltipWaived: "Dispensado",
		tooltipExempt: "Exento",
		tooltipCancelled: "Cancelado",
		tooltipReversed: "Reversado",
		tooltipSettledInMonth: "Saldada en {month} — el cobro es de este período, el dinero entró en aquel mes",
		tooltipForgivenInMonth: "Condonada en {month} — el cobro es de este período; la casa renunció a él aquel mes",
		tooltipEmpty: "Sin movimiento — clic para registrar",
		avulsa: "Puntual",
		chargesTitle: "Cobros",
		seeInMovements: "Ver los movimientos de esta persona",
		monthClosed: "Mes cerrado — no se pueden crear registros",
		multipleCharges: "{count} cobros este mes",
		newCharge: "Nuevo cobro",
		months: {
			"10": "Oct",
			"11": "Nov",
			"12": "Dic",
			"01": "Ene",
			"02": "Feb",
			"03": "Mar",
			"04": "Abr",
			"05": "May",
			"06": "Jun",
			"07": "Jul",
			"08": "Ago",
			"09": "Sep",
		},
	},
	personFinancial: {
		title: "Financiero",
		noHistory: "Sin historial financiero",
		noHistorySubtext: "Los pagos de esta persona aparecerán aquí",
		totalPaid: "Total pagado",
		totalPending: "Total pendiente",
		totalOverdue: "Total atrasado",
		paidAt: "Fecha pago",
	},
	dashboard: {
		viewMovements: "Ver",
		delinquentHint: "Cobros vencidos de las personas morosas, de todos los meses. El panel cuenta personas; cada fila aquí es un cobro.",
		monthlyCollected: "Recaudado en el Mes",
		goalPercent: "Meta Alcanzada",
		remaining: "Faltan",
		overdueCount: "Morosos",
		featuredFunds: "Fondos Destacados",
		receivableTitle: "Cuentas por Cobrar",
		payableTitle: "Cuentas por Pagar",
		bucket: {
			overdue: "Vencidas",
			dueIn7Days: "Vencen en 7 días",
			dueAfter7Days: "Vencen después de 7 días",
			open: "Total",
		},
		committed: "Previsto",
		collected: "Recaudado",
		noFeatured: "Ningún fondo destacado",
		delinquents: "Miembros Morosos",
		noDelinquents: "Ningún miembro moroso",
		totalDue: "Total Debido",
		monthsOverdue: "meses de retraso",
		noChartData: "Sin datos para mostrar el gráfico",
	},
	/**
	 * La válvula de caja (ISSUE-034): el cobro de un mes cerrado no se marca como
	 * pagado en aquel mes — nace un recibo en el mes abierto, y el documento ya
	 * presentado en asamblea sigue diciendo lo que dijo.
	 */
	settlement: {
		valveNotice:
			"El recibo entra en {openMonth}; la caja de {originMonth}, ya cerrado, no cambia.",
		valveNoticeByDueDate:
			"El recibo entra en {openMonth}; la caja de {closedMonth}, cerrado al vencimiento, no cambia.",
		integralOnly:
			"Mes cerrado: solo liquidación íntegra. Para una parte o condonación, use Condonar.",
		settledInMonth: "Saldada en {month}",
		settledInMonthHint: "El cobro sigue en este período; el dinero entró en {month}.",
		legendSettledInMonth: "Saldada en otro mes (período cerrado)",
		receiptOf: "Cobro del período {month}",
		forgivenInMonth: "Condonado",
		forgivenInMonthHint: "Condonada en {month}; el período no cambia.",
		forgivenPartialHint: "Recibido; el resto fue condonado",
		forgivenReason: "Motivo de la condonación",
		legendForgivenInMonth: "Condonado",
		forgivenessOf: "Condonación del período {month}",
		forgivenessOfHint: "Cobro de origen #{code}, de {month}.",
		closedPeriodForgiveness: {
			title: "Condonaciones de períodos cerrados",
			hint: "Detalle por período de origen. Ya cuenta en Condonación de cobro.",
			column: "Período de origen",
			received: "Recibido",
			forgiven: "Condonado",
			full: "Íntegra",
			partial: "Parcial",
		},
		closedPeriodReceipts: {
			title: "Cobros de períodos cerrados",
			hint: "Ya sumados a los ingresos del mes. Los períodos de origen mantienen el cobro pendiente, tal como constaba en el documento de aquel mes.",
			column: "Período de origen",
		},
	},
	/** Condonación de cobro de mes cerrado (ISSUE-036): nace un asiento de condonación en el mes abierto; el mes cerrado no cambia. */
	forgiveness: {
		title: "Condonar cobro de mes cerrado",
		action: "Condonar",
		actionTooltip: "Condonar cobro de mes cerrado",
		insteadOfPaying: "Condonar en vez de recibir",
		notice:
			"{originMonth} está cerrado. La condonación entra en {openMonth}; {originMonth} no cambia.",
		noticeByDueDate:
			"Vencida en {closedMonth}, mes cerrado. La condonación entra en {openMonth}; {closedMonth} no cambia.",
		reasonLabel: "Motivo de la condonación",
		reasonHint: "Queda registrado en la rendición de cuentas",
		reasonRequired: "Indique el motivo de la condonación",
		partialSwitch: "Recibí una parte",
		amountLabel: "Importe recibido",
		amountInvalid: "Mayor que cero y menor que lo cobrado",
		methodRequired: "Indique el método",
		forgivenSummary: "Condonado: {amount}",
		receivedSummary: "Recibido: {amount}",
		success: "Cobro condonado. Movimiento en {month}.",
		confirm: "Condonar",
	},
	report: {
		title: "Informe",
		totalCollected: "Total Recaudado",
		totalCommitted: "Total Previsto",
		adherence: "Adherencia",
		adherenceNoBase: "sin mes cerrado con cobros",
		chargesActive: "Cobros activos",
		allMovements: "Movimientos",
		registeredBy: "Registrado por",
		timeProgress: "Progreso en Tiempo",
		elapsed: "Transcurrido",
		remaining: "Restante",
		chartTitle: "Recaudación Mensual",
		noChartData: "Sin datos para mostrar el gráfico",
		searchPerson: "Buscar persona...",
	},
	insights: {
		analysisTitle: "Análisis del período",
		periodAll: "Todo el historial",
		periodLast6: "Últimos 6 meses",
		periodLast12: "Últimos 12 meses",
		periodCustom: "Período personalizado",
		startMonth: "Desde",
		endMonth: "Hasta",
		applyPeriod: "Aplicar",
		invalidRange: "El mes inicial debe ser anterior o igual al mes final.",
		appliedPeriod: "Período mostrado",
		periodScope: "se aplica a los indicadores y gráficos siguientes",
		pendingTitle: "Cobros pendientes actuales",
		pendingHint: "Situación de hoy, considerando todos los meses. Este bloque es independiente del filtro de período.",
		flowHint: "Entradas y salidas pagadas por mes de referencia, incluidas las transferencias. Compare los valores para entender la variación del saldo.",
		prevRealHint: "Importe previsto en los cobros vinculados a inscripciones y cuánto se ha pagado en cada mes de referencia. El mes actual sigue en curso.",
		adherenceHint: "Porcentaje del importe previsto en los cobros vinculados a inscripciones que ya se ha pagado. Los meses sin previsión no tienen punto; el mes actual aún puede cambiar.",
		agingHint: "Importes pendientes de todos los meses, agrupados por días de atraso. «Al día» incluye cobros aún no vencidos o sin fecha de vencimiento.",
		topDebtorsHint: "Las cinco personas con mayor importe pendiente, considerando todos los meses e incluyendo cobros aún no vencidos.",
		methodHint: "Distribución de los ingresos pagados por forma de pago en los meses de referencia mostrados, sin transferencias entre fondos.",
		categoryHint: "Distribución de los gastos pagados y clasificados por categoría en el período mostrado. Los gastos sin categoría quedan fuera del gráfico.",
		balanceEvolutionTitle: "Evolución del saldo del fondo",
		balanceEvolutionHint: "Saldo por mes de referencia, incluidas las transferencias. Los pagos de meses futuros aparecen en el mes correspondiente. Mes actual en curso.",
		zeroBalance: "Saldo cero",
		currentPosition: "Situación actual · todos los meses",
		adherenceTitle: "Adherencia mensual",
		agingTitle: "Morosidad por atraso",
		flowTitle: "Ingresos y gastos",
		methodTitle: "Recibido por método",
		open: "Pendiente",
		balance: "Saldo",
		income: "Ingresos",
		expense: "Gastos",
		agingCurrent: "Al día",
		aging1_30: "1–30 días",
		aging31_60: "31–60 días",
		aging60plus: "60+ días",
		noData: "Sin datos para mostrar",
		noOpen: "Sin cobros pendientes",
		prevRealTitle: "Previsto vs. cobrado",
		expected: "Previsto",
		received: "Cobrado",
		topDebtorsTitle: "Mayores deudores",
		cumulativeTitle: "Saldo acumulado",
		categoryTitle: "Gastos por categoría",
	},
	settings: {
		title: "Configuración",
	},
	expenseCategories: {
		title: "Categorías de Gasto",
		newCategory: "Nueva Categoría",
		editCategory: "Editar Categoría",
		searchPlaceholder: "Buscar categoría...",
		noCategories: "Sin categorías de gasto",
		noCategoriesSubtext: "Cree categorías para clasificar los gastos del templo",
		movementsCount: "movimientos",
		confirmDelete: "¿Está seguro de que desea eliminar \"{name}\"?",
		stats: {
			total: "Total",
		},
	},
	expenses: {
		registerExpense: "Registrar Gasto",
		category: "Categoría de Gasto",
		fromFund: "De qué fondo sale",
		description: "Descripción",
		descriptionPlaceholder: "Ej: Factura de luz febrero, 10kg de arroz...",
		register: "Registrar",
		validation: {
			categoryRequired: "La categoría es obligatoria",
		},
		scheduleExpense: "Programar Gasto",
		payNow: "Pagar ahora",
		scheduleLater: "Programar",
		recurring: "Recurrente",
		dueDate: "Fecha de vencimiento",
		dueDateRequired: "La fecha de vencimiento es obligatoria para gastos programados",
		scheduledSuccess: "Gasto programado con éxito",
		payExpense: "Pagar gasto",
		expensePaid: "Gasto pagado con éxito",
		methodRequiredForPayment: "El método de pago es obligatorio",
	},
	recurringExpenses: {
		title: "Gastos Recurrentes",
		newExpense: "Nuevo Gasto Recurrente",
		editExpense: "Editar Gasto Recurrente",
		name: "Nombre",
		namePlaceholder: "Ej: Alquiler, Factura de Luz...",
		category: "Categoría",
		fund: "Fondo de salida",
		dueDay: "Día de vencimiento",
		dueDayHint: "Día del mes (1-28)",
		expectedAmount: "Valor esperado",
		isFixed: "Valor fijo",
		isVariable: "Valor variable",
		fixedHint: "El valor es siempre el mismo cada mes",
		variableHint: "El valor puede cambiar cada mes (ej: factura de luz)",
		startDate: "Fecha de inicio",
		endDate: "Fecha de fin",
		endDateHint: "Deje en blanco para recurrencia indefinida",
		active: "Activo",
		inactive: "Inactivo",
		deactivate: "Desactivar",
		activate: "Activar",
		editRecurring: "Editar recurrencia",
		noExpenses: "No hay gastos recurrentes",
		noExpensesSubtext: "Registre gastos que se repiten cada mes, como alquiler, luz e internet",
		searchPlaceholder: "Buscar gastos recurrentes...",
		generatedMovements: "Movimientos generados",
		validation: {
			nameRequired: "El nombre es obligatorio",
			categoryRequired: "La categoría es obligatoria",
			fundRequired: "El fondo es obligatorio",
			dueDayRequired: "El día de vencimiento es obligatorio",
			amountRequired: "El valor es obligatorio",
			startDateRequired: "La fecha de inicio es obligatoria",
		},
		messages: {
			created: "Gasto recurrente creado con éxito",
			updated: "Gasto recurrente actualizado con éxito",
			deactivated: "Gasto recurrente desactivado",
			activated: "Gasto recurrente activado",
		},
	},
	transfers: {
		title: "Transferencia",
		fromFund: "Fondo de Origen",
		toFund: "Fondo de Destino",
		description: "Descripción",
		descriptionPlaceholder: "Ej: Transferencia al fondo de fiesta...",
		transfer: "Transferir",
		balance: "Saldo",
		negativeBalanceWarning: "Atención: esta transferencia dejará el fondo de origen con saldo negativo.",
		percentOfBalance: "Porcentaje del saldo",
		validation: {
			fromFundRequired: "El fondo de origen es obligatorio",
			toFundRequired: "El fondo de destino es obligatorio",
			sameFund: "Los fondos de origen y destino deben ser diferentes",
			percentRange: "Ingrese un valor entre 1% y 100%",
		},
	},
	cashFlow: {
		totalBalance: "Saldo Total",
		monthIncome: "Ingresos del Mes",
		monthExpense: "Gastos del Mes",
		monthBalance: "Saldo del Mes",
		chartTitle: "Flujo de Caja — Ingresos vs Gastos",
		income: "Ingresos",
		expense: "Gastos",
		balance: "Saldo Acumulado",
	},
	messages: {
		categoryCreated: "Categoría creada con éxito",
		categoryUpdated: "Categoría actualizada con éxito",
		categoryDeleted: "Categoría eliminada con éxito",
		expenseCategoryCreated: "Categoría de gasto creada con éxito",
		expenseCategoryUpdated: "Categoría de gasto actualizada con éxito",
		expenseCategoryDeleted: "Categoría de gasto eliminada con éxito",
		fundCreated: "Fondo creado con éxito",
		fundUpdated: "Fondo actualizado con éxito",
		errorLoading: "Error al cargar los datos financieros",
		chargeCreated: "Cobro creado con éxito",
		chargeExempted: "Exención aplicada con éxito",
		chargeUnexempted: "Exención removida con éxito",
		chargeReactivated: "Cobro reactivado con éxito",
		paymentRegistered: "Pago registrado con éxito",
		chargeUpdated: "Cobro actualizado con éxito",
		paymentCancelled: "Pago cancelado con éxito",
		paymentReversed: "Pago reversado con éxito",
		expenseRegistered: "Gasto registrado con éxito",
		transferCompleted: "Transferencia realizada con éxito",
		movementUpdated: "Movimiento actualizado con éxito",
	},
	closing: {
		title: "Cierre Mensual",
		subtitle: "Control de cierre y reportes mensuales",
		close: "Cerrar Mes",
		reopen: "Reabrir Mes",
		confirmClose: "¿Está seguro de que desea cerrar el mes {month}? Nadie podrá crear, editar ni revertir movimientos de este mes desde el sistema.",
		confirmReopen: "¿Está seguro de que desea reabrir el mes {month}?",
		reopenLosesProof: "Reabrir BORRA el hash de integridad de este mes: un informe ya impreso deja de poder verificarse contra el sistema. La observación escrita en el cierre también será sustituida por la que escriba abajo.",
		notes: "Observaciones",
		notesPlaceholder: "Motivo del cierre/reapertura...",
		closingPreview: {
			heading: "Al cerrar {month}, esto queda atrás:",
			charges: "{count} cobro(s) por recibir — {amount}",
			expenses: "{count} cuenta(s) por pagar — {amount}",
			consequence: "Cerrar no cancela nada: la deuda y la cuenta siguen. Lo que se cobre o pague después se registra en el mes abierto en que se anote, y los movimientos y los totales de {month} no cambian.",
		},
		status: {
			OPEN: "Abierto",
			CLOSED: "Cerrado",
		},
		report: {
			title: "Reporte Mensual",
			incomeByFund: "Ingreso por Fondo",
			expenseByCategory: "Gasto por Categoría",
			byMethod: "Ingresos por Método",
			delinquents: "Morosos",
			comparison: "Comparación con Mes Anterior",
			noData: "Sin datos para este mes",
			delta: "Variación",
			income: "Ingreso",
			expense: "Gasto",
			balance: "Saldo",
			total: "Total",
			previousMonth: "Mes Anterior",
			openingBalance: "Saldo anterior",
			movementCount: "Movimientos",
			closedBy: "Cerrado por {user} el {date}",
			reopenedBy: "Reabierto por {user} el {date}",
			noNotes: "No se registró ninguna observación.",
			previousClosings: "Cierres anteriores de este mes",
			previousClosingsHint: "Cada reapertura finaliza el cierre anterior. El código de integridad de abajo es el que se imprimió en los informes de aquella época — sigue siendo válido para esa versión, aunque el mes se haya cerrado de nuevo después.",
			versionNumber: "Cierre {number}",
			supersededBy: "Reabierto por {user} el {date}",
			waived: "Exentos",
			forgiven: "Perdón de cobro",
			closingBalance: "Saldo final acumulado",
		},
		partial: "Parcial",
		partialBanner: "Este reporte es parcial — el mes aún está en curso.",
		closeSequential: "Cierre el mes {month} antes de cerrar este.",
		isClosable: "Listo para cierre",
		viewReport: "Ver Reporte",
		backToList: "Volver",
		recipients: {
			title: "Email de cierre mensual",
			description: "Enviar reporte por email al cerrar el mes",
			admins: "Administradores",
			allUsers: "Todos los usuarios",
			corrente: "Miembros de la corriente",
		},
		messages: {
			monthClosed: "Mes cerrado con éxito",
			monthReopened: "Mes reabierto con éxito",
			error: "Error al procesar el cierre",
		},
	},
	payment: {
		title: "Pagos en línea",
		feeConfig: {
			title: "Registro de la comisión de Mercado Pago",
			description:
				"Mercado Pago cobra una comisión por transacción (PIX 0,99%, tarjeta ~4,98%) y la descuenta antes de que el dinero llegue a la cuenta del templo — es decir, ingresa menos de lo que pagó el miembro. Para que la rendición de cuentas sea correcta, ORI mantiene el pago por el importe completo y registra automáticamente esa diferencia como un gasto \"Comisión Mercado Pago\", vinculado al movimiento de origen. Así, el saldo del fondo refleja exactamente el importe neto realmente recibido.",
			example:
				"Ejemplo: el miembro paga R$ 50,00 por PIX → el templo recibe R$ 49,50 y ORI registra un gasto de R$ 0,50 (\"Comisión Mercado Pago - mov 260100\"). El saldo del fondo muestra los R$ 49,50 que realmente ingresaron.",
			enabledLabel: "Registrar la comisión de Mercado Pago como gasto",
			fundSame: "En el mismo fondo que recibió el pago",
			fundFixed: "Siempre en un fondo específico",
			fundSelect: "Fondo del gasto de la comisión",
			noFunds: "Ningún fondo registrado",
			disableTitle: "¿Desactivar el registro de la comisión?",
			disableWarning:
				"Recomendamos encarecidamente mantener esta opción activada.\n\nSin el registro de la comisión, el saldo de sus fondos quedará sobreestimado: el sistema registra el importe completo cobrado al miembro, pero la cuenta del templo en Mercado Pago recibe menos, porque la comisión ya fue descontada. Su rendición de cuentas dejará de reflejar el dinero que realmente ingresó.\n\nDesactive solo si es plenamente consciente de esta distorsión y pretende conciliar la comisión manualmente.",
			disableConfirm: "Desactivar de todos modos",
			saveSuccess: "Configuración de la comisión guardada",
			saveError: "Error al guardar la configuración de la comisión",
		},
		autoDebitConfig: {
			enabledLabel: "Permitir cobro automático (débito recurrente con tarjeta)",
			description:
				"Cuando está activo, los miembros pueden autorizar el débito automático mensual y tú puedes activarlo en los cobros. Desactivado, solo queda el PIX — el botón de cobro automático deja de aparecer. Los débitos automáticos ya autorizados siguen activos y pueden pausarse o cancelarse.",
			saveSuccess: "Preferencia de cobro automático guardada",
			saveError: "Error al guardar la preferencia de cobro automático",
		},
		consent: {
			title: "Antes de conectar Mercado Pago",
			intro:
				"Al conectar tu cuenta, los pagos de los miembros pasarán a ser procesados por Mercado Pago. Antes de continuar, confirma que eres consciente de que:",
			fees:
				"Mercado Pago cobra una comisión por transacción (PIX 0,99%, tarjeta de crédito ~4,98%), descontada automáticamente. ORI no cobra nada adicional.",
			netAmount:
				"El importe depositado en la cuenta del templo será menor que el importe pagado por el miembro, porque la comisión se descuenta antes de la liberación.",
			feeExpense:
				"ORI registra automáticamente esa comisión como un gasto \"Comisión Mercado Pago\" en Finanzas, para que el saldo de los fondos refleje el importe neto recibido (ajustable en la configuración de la integración).",
			responsibility:
				"Las comisiones, los plazos de liberación y las políticas son responsabilidad de Mercado Pago, no de ORI. Eres responsable de la cuenta conectada y de verificar los importes recibidos.",
			checkbox: "He leído y estoy de acuerdo con las condiciones anteriores.",
			confirm: "Conectar Mercado Pago",
		},
		connect: "Conectar Mercado Pago",
		disconnect: "Desconectar",
		connected: "Conectado",
		connectedAs: "Cuenta: {account}",
		fees: "Tarifas de Mercado Pago: PIX 0,99% · tarjeta ~4,98% (~3,98% tras 30 días). ORI no cobra nada extra.",
		expired: "Expirado",
		revoked: "Desconectado",
		notConnected: "Ninguna cuenta de pago conectada",
		moduleMissing:
			"ORI Pagos (integración Mercado Pago) no está incluido en tu plan. Contrata el módulo en la pantalla del plan para conectar.",
		connectRequired: "Conecta Mercado Pago en Integraciones para usar esta función",
		connectSuccess: "Cuenta de pago conectada con éxito",
		connectError: "Error al conectar la cuenta de pago",
		charge: {
			button: "Cobrar en línea",
			generating: "Generando cobro...",
			copyLink: "Copiar enlace",
			linkCopied: "Enlace copiado",
			created: "Cobro generado",
			error: "Error al generar el cobro",
			emailSent: "Enviado por correo a",
		},
		mandate: {
			enable: "Cobro automático",
			column: "Cobro automático",
			manualBlocked:
				"Esta cuota está en cobro automático — Mercado Pago la cobra automáticamente. No se permite el pago manual. Pausa el cobro automático para cobrar de otra forma.",
			manualBlockedShort: "En cobro automático — pago manual bloqueado",
			pauseToPayManually: "Pausar cobro automático",
			activate: "Activar cobro automático",
			resendLink: "Reenviar enlace de autorización",
			pause: "Pausar",
			resume: "Reanudar",
			cancel: "Cancelar cobro automático",
			pausedSuccess: "Cobro automático pausado",
			resumedSuccess: "Cobro automático reanudado",
			cancelledSuccess: "Cobro automático cancelado",
			authorizePrompt: "Active el cobro automático mensual de esta cuota.",
			confirmCancelTitle: "¿Cancelar el cobro automático?",
			confirmCancelText:
				"El débito automático mensual dejará de realizarse. Podrá activarlo nuevamente después.",
			state: {
				NONE: "Cobro automático: desactivado",
				PENDING: "Esperando que el miembro autorice",
				AUTHORIZED: "Cobro automático: activo",
				PAUSED: "Cobro automático: pausado",
			},
			tip: {
				NONE: "Cobro automático desactivado. Actívelo para que el miembro autorice el débito mensual.",
				PENDING: "Esperando que el miembro autorice el débito automático mediante el enlace enviado.",
				AUTHORIZED:
					"Cobro automático activo — al miembro se le debita cada mes. Pausar lo detiene sin cancelar.",
				PAUSED: "Cobro automático pausado — los débitos están suspendidos. Reanude para volver a cobrar.",
			},
		},
		status: {
			PENDING: "Pendiente",
			AUTHORIZED: "Autorizada",
			PAUSED: "Pausada",
			CANCELLED: "Cancelada",
			PAID: "Pagado",
			EXPIRED: "Expirado",
			FAILED: "Fallido",
		},
	},
	pay: {
		loading: "Cargando...",
		notFound: "Cobro no encontrado o expirado",
		autoMandateTitle: "¿Cansado de pagar todos los meses?",
		autoMandateText:
			"Active el cobro automático y deje de pagar manualmente — autoriza una vez y listo.",
		enableAutoMandate: "Activar cobro automático",
		autoMandateError: "No se pudo activar el cobro automático. Inténtelo de nuevo.",
		title: "Pago",
		amount: "Importe",
		temple: "Templo",
		month: "Mes",
		payWith: "Pagar con",
		pixTab: "PIX copiar y pegar",
		cardTab: "Tarjeta",
		copyCode: "Copiar código PIX",
		codeCopied: "¡Código copiado!",
		paid: "Pago confirmado",
		expiredHint: "El código PIX tiene validez limitada. Genera uno nuevo para pagar ahora.",
		noPaymentDue: "Este cobro está cerrado. No hay ningún pago pendiente.",
		forgiven: "Cobro condonado por la casa. Nada que pagar.",
		generateNewPix: "Generar nuevo PIX",
		generateNewPixError: "No se pudo generar un nuevo PIX. Inténtelo de nuevo.",
		expired: "Este cobro ha expirado",
		authorize: "Autorizar cobro automático",
		pixExpiryNotice: "Este código PIX vence {time}. No programes el pago.",
		autoDebitUnavailable:
			"El cobro automático ya no está disponible en este templo. Habla con la administración para acordar otra forma de pago.",
	},
};
